import type { SpinnerProps as ChakraSpinnerProps } from '@chakra-ui/react';
import { Spinner as ChakraSpinner } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type SpinnerProps = OmitChakraProps<
  ChakraSpinnerProps,
  'speed' | 'orientation' | 'styleConfig' | 'colorScheme' | 'variant' | 'size'
> & {
  variant?: 'neutral' | 'default';
  size?: 'lg' | 'md' | 'sm' | 'xs' | 'tiny';
};

export const Spinner = withChakraAs<SpinnerProps, 'div'>((props) => (
  <ChakraSpinner {...props} speed="0.6s" />
));
